import Swiper from "swiper/bundle";

export default class Thumbnail {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const thumboption = {
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        };

        const swipersub = new Swiper(".slider__sub", thumboption);
        const slides = [...document.querySelectorAll(".slider__sub .swiper-slide")];

        const option = {
            autoplay: slides.length > 1 ? { delay: 5000 } : false,
            loop: true,
            slidesPerView: 1.2,
            breakpoints: {
                834: { slidesPerView: 1 },
            },
            centeredSlides: true,
            thumbs: { swiper: swipersub },
        };

        const swiper = new Swiper(".thumbnail__cont", option);
    }
}
